//deps
import styled from "styled-components";

export const Container = styled.div`
    position: fixed;
    left: -100vw;
    bottom: "4px";
    top: -100vh;
    right: -100vw;
    z-index: -1;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    background: ${props => props.theme.colors.light.background_Overlay_Light};
`;
